import format from 'string-template';

import texts from './texts.json';

const ContractEditorTabs = {
  CONTRACT: 'CONTRACT',
  SECONDARY_CONTRACT: 'SECONDARY_CONTRACT',
};

const contractEditorTabsConfig = (discountPercentage) => ({
  [ContractEditorTabs.CONTRACT]: {
    label: texts.monthlyPlan,
  },
  [ContractEditorTabs.SECONDARY_CONTRACT]: {
    label: format(texts.upfrontPlan, { discountPercentage }),
  },
});

export {
  ContractEditorTabs,
  contractEditorTabsConfig,
};
